var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLegalProceedingsOther(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1144_1074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.125 6.25L12.7394 10.8862C13.2537 11.3988 13.2537 12.2288 12.7394 12.7406C12.4923 12.9864 12.1579 13.1244 11.8094 13.1244C11.4608 13.1244 11.1265 12.9864 10.8794 12.7406L6.25 8.125",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 5.625L6.25 8.125",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.125 6.25L5.625 3.75",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.875 13.125H6.25",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.24565 9.87062L2.0044 7.62937C1.88723 7.51217 1.82141 7.35323 1.82141 7.1875C1.82141 7.02177 1.88723 6.86283 2.0044 6.74562L3.43753 5.3125L3.75003 5.625L5.62503 3.75L5.31253 3.4375L6.74565 2.00437C6.86286 1.8872 7.0218 1.82138 7.18753 1.82138C7.35326 1.82138 7.5122 1.8872 7.6294 2.00437L9.87065 4.24562C9.98782 4.36283 10.0536 4.52177 10.0536 4.6875C10.0536 4.85322 9.98782 5.01217 9.87065 5.12937L8.43753 6.5625L8.12503 6.25L6.25003 8.125L6.56253 8.4375L5.1294 9.87062C5.0122 9.98779 4.85326 10.0536 4.68753 10.0536C4.5218 10.0536 4.36286 9.98779 4.24565 9.87062Z",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1144_1074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalProceedingsOther);
export default __webpack_public_path__ + "static/media/legalProceedingsOther.d1b2c301c48e5abd0e6ad4aad71e0273.svg";
export { ForwardRef as ReactComponent };